import { z } from 'zod';
import { nameField } from './name.schema';
import { phoneField } from './phone.schema';
import { cpfField } from './cpf.schema';
import { emailField } from './email.schema';

export const signUpSchema = z.object({
  name: nameField,
  phone: phoneField,
  cpf: cpfField,
  email: emailField,
  password: z.string().min(8, 'A senha deve ter pelo menos 8 caracteres')
});

export type SignUpSchema = z.infer<typeof signUpSchema>;
